"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_SUGGESTED_ACTIONS = void 0;
exports["default"] = clearSuggestedActions;
var CLEAR_SUGGESTED_ACTIONS = 'WEB_CHAT/CLEAR_SUGGESTED_ACTIONS';
exports.CLEAR_SUGGESTED_ACTIONS = CLEAR_SUGGESTED_ACTIONS;
function clearSuggestedActions() {
  return {
    type: CLEAR_SUGGESTED_ACTIONS
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDTEVBUl9TVUdHRVNURURfQUNUSU9OUyIsImV4cG9ydHMiLCJjbGVhclN1Z2dlc3RlZEFjdGlvbnMiLCJ0eXBlIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvY2xlYXJTdWdnZXN0ZWRBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TID0gJ1dFQl9DSEFUL0NMRUFSX1NVR0dFU1RFRF9BQ1RJT05TJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY2xlYXJTdWdnZXN0ZWRBY3Rpb25zKCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TXG4gIH07XG59XG5cbmV4cG9ydCB7IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyxrQ0FBa0M7QUFBQ0MsT0FBQSxDQUFBRCx1QkFBQSxHQUFBQSx1QkFBQTtBQUVwRCxTQUFTRSxxQkFBcUJBLENBQUEsRUFBRztFQUM5QyxPQUFPO0lBQ0xDLElBQUksRUFBRUg7RUFDUixDQUFDO0FBQ0gifQ==